import apis, { formAxios } from "../index";

export const getPagesApi = async (payload) => {
  try {
    const response = await apis.get(
      `posts?filters[type]=page&paginate=1&page=${payload?.page}&pagination_size=${payload?.pageSize}`,
      payload
    );
    const data = await response;
    // Return data or handle response as needed
    return data;
  } catch (error) {
    // Handle errors appropriately
    console.error("Error during fetching pots:", error);
    throw error;
  }
};

export const getPageBySlugApi = async (slug) => {
  try {
    const response = await apis.get(`posts/${slug}`);
    const data = await response;
    // Return data or handle response as needed
    return data;
  } catch (error) {
    // Handle errors appropriately
    console.error("Error during fetching pots:", error);
    throw error;
  }
};

export const addPageApi = async (payload) => {
  try {
    // Call your login API endpoint here
    const response = await formAxios.post("posts", payload);
    const data = await response;
    // Return data or handle response as needed
    return data;
  } catch (error) {
    // Handle errors appropriately
    console.error("Error during fetching posts:", error);
    throw error;
  }
};

export const updatePageApi = async (payload, id) => {
  try {
    // Call your login API endpoint here
    const response = await formAxios.post(`posts/${id}`, payload);
    const data = await response;
    // Return data or handle response as needed
    return data;
  } catch (error) {
    // Handle errors appropriately
    console.error("Error during updaing posts:", error);
    throw error;
  }
};
export const pageApproveApi = async (payload, id) => {
  try {
    // Call your login API endpoint here
    const response = await apis.put(`posts/${id}/approval-status`, payload);
    const data = await response;
    // Return data or handle response as needed
    return data;
  } catch (error) {
    // Handle errors appropriately
    console.error("Error during updaing posts:", error);
    throw error;
  }
};

export const deletePageApi = async (id) => {
  try {
    // Call your login API endpoint here
    const response = await apis.delete(`posts/${id}`);
    const data = await response;
    // Return data or handle response as needed
    return data;
  } catch (error) {
    // Handle errors appropriately
    console.error("Error during deleting posts:", error);
    throw error;
  }
};
